import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { Button } from "@mui/material";

import CustomTable from "components/common/table/CustomTable";
import useReferringProviders from "./hooks/useReferringProviders";
import ReferringProviderModal from "./modal/ReferringProviderModal";
import DeleteConfirmationModal from "./modal/DeleteConfirmationModal";

const ReferringProviders = () => {
  const {
    columns,
    referringProviders,
    isFetching,
    showReferringProviderModal,
    handleAddReferringProvider,
    showDeleteConfirmationModal,
  } = useReferringProviders();

  return (
    <div>
      <div id="userTable">
        <div className="trans-table__container">
          <CustomTable
            data={referringProviders || []}
            columns={columns}
            options={{
              enableTopToolbar: true,
              state: {
                isLoading: isFetching,
                showGlobalFilter: true,
                showColumnFilters: true,
              },
              renderTopToolbar: ({ table }) => (
                <div
                  className="d-flex justify-between"
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #e0e0e0",
                    gap: "10px",
                  }}
                >
                  <GlobalFilterTextField table={table} />
                  <Button
                    onClick={handleAddReferringProvider}
                    size="small"
                    color="secondary"
                    variant="contained"
                  >
                    + Add Referring Provider
                  </Button>
                </div>
              ),
            }}
          />
          {showReferringProviderModal && <ReferringProviderModal />}
          {showDeleteConfirmationModal && <DeleteConfirmationModal />}
        </div>
      </div>
    </div>
  );
};

export default ReferringProviders;
